import Client from '../client';
import {flattenObject} from '../helpers';
import {
  GetAllCustomersRequestBuilder,
  GetAllOrganRequestBuilder,
  PostOrganRequestBuilder,
} from '../helpical/categories';
import {
  GetAllUsersRequestBuilder,
  GetUsersCountRequestBuilder,
  UpdateUserRequestBuilder,
  DeleteUserBuilder,
  CreateUserRequestBuilder,
  UpdateUserStatusRequestBuilder,
  GetUserProfileRequestBuilder,
  UpdateUserProfileRequestBuilder,
} from '../users/users';

const token = localStorage.getItem('token') || '';

class UsersRepository {
  getUsers = async (actions: any) => {
    const makeRequest = new GetAllUsersRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();
    const makeCountRequest = new GetUsersCountRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    const count = await client.execute(makeCountRequest);
    return {response, count};
  };
  getCustomers = async (actions: any) => {
    const makeRequest = new GetAllCustomersRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();
    // const makeCountRequest = new GetAllCustomersRequestBuilder()
    //   .params(flattenObject({...actions.payload, sort: 'id,desc'}))
    //   .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    // const count = await client.execute(makeCountRequest);
    return {response};
  };
  getProfile = async (actions: any) => {
    const makeRequest = new GetUserProfileRequestBuilder()
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  updateProfile = async (actions: any) => {
    const {body} = actions.payload;
    const makeRequest = new UpdateUserProfileRequestBuilder().data(body).build();
    const client = new Client(token);
    await client.execute(makeRequest);
    return body;
  };
  getOrgans = async (actions: any) => {
    const makeRequest = new GetAllOrganRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return {response};
  };
  postOrgans = async (actions: any) => {
    const makeRequest = new PostOrganRequestBuilder()
      .data(flattenObject({...actions.payload}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return {response};
  };

  getUserWithId = async (actions: any) => {
    const makeRequest = new GetAllUsersRequestBuilder()
      .id(actions.payload.id)
      .build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  updateUser = async (actions: any) => {
    const {body, pagination, callback} = actions.payload;
    const makeRequest = new UpdateUserRequestBuilder().data(body).build();
    const client = new Client(token);
    await client.execute(makeRequest);
    return {pagination, callback};
  };
  createUser = async (actions: any) => {
    const {body, pagination, callback} = actions.payload;
    const makeRequest = new CreateUserRequestBuilder().data(body).build();
    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return {pagination, callback, response};
  };
  updateUserStatus = async (actions: any) => {
    const {id, body, pagination} = actions.payload;
    const makeUpdateStatusRequest = new UpdateUserStatusRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    await client.execute(makeUpdateStatusRequest);
    return pagination;
  };
  cancelUser = async (actions: any) => {
    const {id} = actions.payload;
    const makeRequest = new DeleteUserBuilder().id(id).build();
    const client = new Client(token);
    await client.execute(makeRequest);
  };
  getUsersByPartnerId = async (actions: any) => {
    const makeRequest = new GetAllUsersRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  getUsersBeAdminPartner = async (actions: any) => {
    const makeRequest = new GetAllUsersRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  getUsersByCenterId = async (actions: any) => {
    const makeRequest = new GetAllUsersRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  getUsersBeAdminCenter = async (actions: any) => {
    const makeRequest = new GetAllUsersRequestBuilder()
      .params(flattenObject({...actions.payload, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
}

export default new UsersRepository();
